<template>
  <div ref="typebotContainer" class="typebot-container"></div>
</template>

<script>
export default {
  name: 'TypebotChat',
  data() {
    return {
      typebotInitializing: false,
    }
  },
  computed: {
    typebot() {
      if (this.$i18n.locale === 'ar') {
        return 'ilajnafsy-chatbot-arb-cbiu1yw'
      } else {
        return 'ilajnafsy-chatbot-en-5mdw1bf'
      }
    },
    currentLocale() {
      return this.$i18n.locale
    },
  },
  watch: {
    currentLocale() {
      // Bei Sprachwechsel komplett neu laden
      this.reloadTypebot()
    },
  },
  mounted() {
    if (!window.__initialTypebotLoaded) {
      window.__initialTypebotLoaded = true
      this.loadTypebot()
    }
  },
  beforeDestroy() {
    this.removeTypebotScript()
    window.__initialTypebotLoaded
  },
  methods: {
    loadTypebot() {
      console.log('initializing typebot')
      this.cleanupTypebot()

      // Bestehendes Skript entfernen
      this.removeTypebotScript()

      // Container leeren
      if (this.$refs.typebotContainer) {
        this.$refs.typebotContainer.innerHTML = ''
      }

      if (
        document.getElementById('typebot-script') ||
        document.querySelectorAll('typebot-bubble').length > 0
      ) {
        return
      }

      // Neues Skript erstellen
      const script = document.createElement('script')
      script.id = 'typebot-script'
      script.type = 'module'
      script.innerHTML = `
        import Typebot from "https://cdn.jsdelivr.net/npm/@typebot.io/js@0.8.20/dist/web.js";

        window.Typebot = Typebot
        console.log('Initializing Typebot-Bubble with typebot ID: ${this.typebot}')
        Typebot.initBubble({
          typebot: "${this.typebot}",
          apiHost: "https://typebot.co",
          theme: {
            button: {
              backgroundColor: "transparent",
              size: "large",
            },
            chatWindow: {
              backgroundColor: "#f1f1f1"
            },
          },
        });
      `
      document.body.appendChild(script)
    },
    cleanupTypebot() {
      // 1. Altes Skript entfernen
      const oldScript = document.getElementById('typebot-script')
      if (oldScript) {
        oldScript.remove()
      }

      //typebot-bubble-Elemente entfernen
      const bubbles = document.querySelectorAll('typebot-bubble')

      // Jedes Element entfernen
      bubbles.forEach(bubble => {
        bubble.remove()
      })

      // 2. Container komplett leeren (das entfernt ALLE Kinder)
      if (this.$refs.typebotContainer) {
        this.$refs.typebotContainer.innerHTML = ''
      }

      // 3. Globales Typebot-Objekt löschen
      delete window.Typebot
    },
    removeTypebotScript() {
      // Altes Skript entfernen
      const oldScript = document.getElementById('typebot-script')
      if (oldScript) {
        oldScript.remove()
      }

      // Globales Typebot-Objekt löschen
      delete window.Typebot
    },

    reloadTypebot() {
      this.loadTypebot()
    },
  },
}
</script>

<style scoped>
.typebot-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}
</style>
